var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemarksIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.47559,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "#262170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47559,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#7972E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9756 18C22.9756 18.3536 22.8351 18.6928 22.5851 18.9428C22.335 19.1929 21.9959 19.3333 21.6423 19.3333H13.6423L10.9756 22V11.3333C10.9756 10.9797 11.1161 10.6406 11.3661 10.3905C11.6162 10.1405 11.9553 10 12.3089 10H21.6423C21.9959 10 22.335 10.1405 22.5851 10.3905C22.8351 10.6406 22.9756 10.9797 22.9756 11.3333V18Z",
    stroke: "#7972E0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarksIconDark);
export default __webpack_public_path__ + "static/media/remarks-icon-dark.5ca1430ae54f2de9f313a809bda5cbd9.svg";
export { ForwardRef as ReactComponent };